var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_64506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5C33 7.3873 25.6127 0 16.5 0C7.3873 0 0 7.3873 0 16.5C0 24.7356 6.03381 31.5617 13.9219 32.7995V21.2695H9.73242V16.5H13.9219V12.8648C13.9219 8.72953 16.3852 6.44531 20.1541 6.44531C21.9594 6.44531 23.8477 6.76758 23.8477 6.76758V10.8281H21.767C19.7173 10.8281 19.0781 12.1 19.0781 13.4049V16.5H23.6543L22.9228 21.2695H19.0781V32.7995C26.9662 31.5617 33 24.7356 33 16.5Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9228 21.2695L23.6543 16.5H19.0781V13.4049C19.0781 12.1 19.7173 10.8281 21.767 10.8281H23.8477V6.76758C23.8477 6.76758 21.9594 6.44531 20.1541 6.44531C16.3852 6.44531 13.9219 8.72953 13.9219 12.8648V16.5H9.73242V21.2695H13.9219V32.7995C15.6302 33.0668 17.3698 33.0668 19.0781 32.7995V21.2695H22.9228Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_64506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.6dc78d6da3b887d428cc6a563bdbc27d.svg";
export { ForwardRef as ReactComponent };